<div class="app-shell" [class.sidebar-collapsed]="!isSliderOpen">

  <aside class="sidebar" [class.open]="isSliderOpen" (mouseleave)="closeSidebar()">
    <div class="offcanvas-header">
      <span class="header-breadcrumb" *ngIf="commonDataObject.selectedProject as project">
        <span> {{ project.project_name }}</span>
      </span>
      <span class="toggle-icon-btn" (click)="pinUnpinSidebar()" title="Close sidebar">
        <i *ngIf="!isPin" class="fas fa-thumbtack"></i>
        <i *ngIf="isPin" class="fas fa-thumbtack pined"></i>
      </span>
    </div>

    <nav class="offcanvas-body">
      <ul class="main_menu_link">
        <li class="nav-item" *ngFor="let menu of commonDataObject.filteredUserMenu">
          <a class="nav-link" [routerLink]="menu.route" [queryParams]="getQueryParams(menu)"
            routerLinkActive="active-link">
            <i [class]="menu.icon" class="menu-icon"></i>
            {{ menu.label }}
          </a>
        </li>
      </ul>
    </nav>
  </aside>

  <div class="main">

    <header class="header">
      <div class="header-left">
        <span *ngIf="!isSliderOpen" class="navigation-icon" (mouseenter)="openSidebar()" title="Toggle Sidebar">
          <i class="fa-solid fa-bars-staggered" style="font-size: 30px;"></i>
        </span>
        <div style="display: flex; flex-direction: row; align-items: center; gap: 10px;">
          <span style="display: flex; flex-direction: row; align-items: center; cursor: pointer;"
            (click)="backToAnalitycs()">
            <i class="fa-solid fa-circle-chevron-left" style="font-size: 24px;"></i>
          </span>
          <h5 class="current-route-name"><span>{{ routeName }}</span></h5>
        </div>
      </div>

      <div class="header-right">

        <div class="d-flex">
          <div class="sidebar-dropdown-wrap" id="pSelectDropdown">
            <p-select #pSelect class="sidebar-dropdown" [resetFilterOnHide]="true" id="project_name" appendTo="body"
              [options]="projectService.getPermittedProjects()" placeholder="Select Project" optionLabel="project_name"
              [ngModel]="commonDataObject.selectedProject" (ngModelChange)="onProjectChange($event)">
            </p-select>
          </div>

          <div class="user-account" id="userAccount" (click)="toggleUserMenu($event)">
            <div class="user-profile-info">
              <div class="user-profile-name">{{ commonDataObject.uName }}</div>
            </div>
            <div class="topbar-avatar">
              {{ commonDataObject.uName?.charAt(0)?.toUpperCase() || 'U' }}
            </div>
          </div>

          <div class="account-details" [class.show]="isUserMenuOpen">
            <ul class="account-menu">
              <li class="account-menu-item" (click)="resetPw()">
                <svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" viewBox="0 0 24 24">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0110 0v4" />
                </svg>
                Reset Password
              </li>
              <li class="account-menu-divider"></li>
              <li class="account-menu-item danger" (click)="logoutApp()">
                <svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" viewBox="0 0 24 24">
                  <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
                Logout
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>

    <main class="main-content">
      <router-outlet></router-outlet>
    </main>

  </div>
</div>

<div class="alert-message" [class.show]="commonDataObject.issuccessAlert || commonDataObject.iserrorAlert"
  [class.success]="commonDataObject.issuccessAlert" [class.error]="commonDataObject.iserrorAlert">
  <i class="fas" [class.fa-check-circle]="commonDataObject.issuccessAlert"
    [class.fa-exclamation-circle]="commonDataObject.iserrorAlert"></i>
  <span>{{ commonDataObject.apiMeassge }}</span>
  <i class="fas fa-times close-alert"
    (click)="commonDataObject.issuccessAlert = false; commonDataObject.iserrorAlert = false"></i>
</div>